import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ConfigurationService, ForceBaseUrl } from '../../configuration/configuration.service';
import { EndpointFactory } from '../../endpoint-factory.service';

@Injectable({
    providedIn: 'root'
})
export class CommunityProgramsEndpoint extends EndpointFactory {



    getServiceBaseUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('community', force) + 'community';
    }


    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {

        super(http, configurations, injector);
    }

    getReferrals(tenantId: string, memberId: string): Observable<string[]> {
        const endpointUrl = `${this.getServiceBaseUrl()}/GetReferralsByMemberId/${tenantId}/${memberId}`;

        return this.http.get<string[]>(endpointUrl).pipe(
            catchError(error => {
                return this.handleError(error);
            })
        );
    }
}
